module.exports = __webpack_public_path__ + "img/code_3.103a0d27.png";